<template>
    <b-navbar toggleable="md" type="light" :class="['border-bottom border-color-gray-300 bg-white qesg-navbar', { collapsed: collapsedSidebar }]">
        <b-navbar-brand class="mr-2">
            <b-btn variant="light" :aria-label="$t(collapsedSidebar ? '사이드 메뉴 펼치기' : '사이드 메뉴 접기')" @click="$emit('collapseSidebar')">
                <b-icon-chevron-bar-left  v-show="!collapsedSidebar" />
                <b-icon-chevron-bar-right v-show="collapsedSidebar" />
            </b-btn>
        </b-navbar-brand>
        <div class="qesg-navbar__project">
            <b-card v-if="!GET_ProjectList.length" no-body class="shadow-xs">
                <div
                    class="d-flex align-items-center rounded text-secondary"
                    >
                    <div v-if="projectListError" class="d-flex flex-wrap align-items-center py-2 px-3">
                        <h6 class="font-weight-normal text-danger mb-0">
                            {{ $t('프로젝트 목록을 불러오지 못했습니다.')}}
                        </h6>
                        <b-btn size="sm" variant="outline-secondary" class="ml-2" @click="$emit('retry')">
                            {{ $t('다시 시도') }}
                        </b-btn>
                    </div>
                    <div v-else-if="!isProjectLoaded" class="py-2 px-3">
                        <h6 class="font-weight-normal font-italic mb-0">
                            {{ $t('생성된 프로젝트가 없습니다.')}}
                        </h6>
                    </div>
                </div>
            </b-card>

            <auto-complete-select v-else
                                  ref="autoComplete"
                                  v-model="selectedProjectCodeId"
                                  :options="projectCodeOptions"
                                  :aria-label="$t('프로젝트 선택')"
                                  :loading="isProjectLoaded"
                                  startExpanded
                                  option-value-key="id"
                                  :placeholder="$t('프로젝트를 선택해주세요.')"
                                  @click="onItemClick" />
        </div>
        <b-navbar-toggle target="contractor-navbar-actions" class="ml-2" :label="$t('메뉴')" />
        <b-collapse id="contractor-navbar-actions" is-nav>
            <b-navbar-nav class="ml-auto align-items-md-center mt-2 mt-md-0">
                <li class="nav-item">
                    <b-btn
                        variant="light"
                        class="border d-flex align-items-center"
                        @click="openDownloadExcelModal"
                        >
                        <span class="mr-2">{{ $t('프로젝트별 엑셀 일괄 다운로드') }}</span>
                        <b-icon-download class="ml-0" />
                    </b-btn>
                </li>
                <li class="nav-item my-2 my-md-0 mx-md-2">
                    <dropdown-language dropdownVariant="secondary" />
                </li>
                <li class="nav-item">
                    <b-button
                        size="sm"
                        variant="dark-border"
                        @click="logout"
                        >
                        {{ $t('로그아웃') }}
                    </b-button>
                </li>
            </b-navbar-nav>
        </b-collapse>
        <contractor-excel-download-modal/>
    </b-navbar>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
// import dayjs from 'dayjs';
import {
    BIconChevronBarLeft, BIconChevronBarRight
} from 'bootstrap-vue';
import DropdownLanguage from '@shared_components/utils/dropdown-language';
import AutoCompleteSelect from '@core_components/common/AutoCompleteSelect.vue';
import ContractorExcelDownloadModal
    from '@shared/components/contractor/components/ContractorExcelDownload/ContractorExcelDownloadModal.vue';
export default {
    name: 'contractor-navigation-bar',
    components: {
        AutoCompleteSelect,
        ContractorExcelDownloadModal,
        BIconChevronBarLeft,
        BIconChevronBarRight,
        DropdownLanguage
    },
    props: {
        isProjectLoaded: {
            required: true,
            type: Boolean
        },
        collapsedSidebar: {
            required: true,
            type: Boolean
        },
        projectListError: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            selectedProjectCodeId: null,
        };
    },
    computed: {
        ...mapState(['user_id']),
        ...mapGetters('contractor', [ 'Get_Contractor', 'GET_ProjectList' ]),
        getActiveProject () {
            if (!this.GET_ProjectList) {
                return null;
            } else {
                let _active_project = this.GET_ProjectList.find(_project => _project.project_code === this.$route.query.projectid);
                if (_active_project) {
                    return _active_project;
                } else {
                    return null;
                }
            }
        },
        // 묶음은 period 원문(2025_1h)으로 최신순 정렬하고, 제목은 화면 언어의 기간 표기(2025년 상반기)로 보인다.
        // period_dis 는 period 에 '_' 가 있을 때만 만들어지므로 없으면 원문을 쓴다
        projectCodeOptions(){
            const mapOptions = {};
            this.GET_ProjectList.forEach((item,idx) => {
                if(mapOptions[item.period] == null) {
                    mapOptions[item.period] = [];
                }
                mapOptions[item.period].push({
                    value: item,
                    text: `${item.project_code} (${this.periodText(item)})`,
                    id: idx
                });
            });
            return Object.keys(mapOptions)
                .sort((a, b) => b.localeCompare(a))
                .map(key => ({
                    group: this.periodText(mapOptions[key][0].value),
                    items: mapOptions[key]
                }));
        }
    },
    watch: {
        '$route.query.projectid' () {
            this.syncSelectedProject();
        },
        projectCodeOptions: {
            deep: true,
            handler(){
                this.syncSelectedProject();
            }
        }
    },
    mounted () {
        
    },
    beforeDestroy () {},
    methods: {
        periodText (project) {
            return project.period_dis?.[this.$i18n.locale] || project.period || '-';
        },
        // 선택기 표시값은 항상 URL 의 projectid 를 따른다 (뒤로가기·앞으로가기 포함)
        syncSelectedProject () {
            const { projectid } = this.$route.query;
            let _selected = null;
            this.projectCodeOptions.forEach(group => {
                const foundItem = group.items.find(item => item.value.project_code === projectid);
                if (foundItem) {
                    _selected = foundItem.id;
                }
            });
            this.selectedProjectCodeId = _selected;
        },
        // 같은 프로젝트를 다시 고르면 이동하지 않는다. 이동이 막히면(이탈 확인 취소 등) 선택기를 URL 값으로 되돌린다
        onItemClick(item){
            this.$refs.autoComplete.hideList();
            if (item.value.project_code === this.$route.query.projectid) return;
            this.$router.push({
                name: this.$route.name,
                params: {
                    requestsId: this.Get_Contractor.company_id,
                },
                query: {
                    projectid: item.value.project_code
                }
            }).catch(() => this.syncSelectedProject());
        },
        async logout () {
            // 서버 로그아웃이 실패해도 로컬 세션은 이미 정리됐으므로 로그인 화면으로 보낸다 (안내는 두지 않음 — X1-04 와 동일)
            try {
                await this.$store.dispatch('contractor/LogoutContractor');
            } catch (error) {
                // 로컬 정리는 LogoutContractor 의 finally 가 끝냈다
            } finally {
                this.$router.push({ name: 'Login' });
            }
        },
        openDownloadExcelModal () {
            this.$bvModal.show('contractor-excel-download-modal');
        },
    }
};
</script>

<style lang="scss">
.dropdown-project-select-menu {
    max-height: 80vh;
    overflow-y: auto;
}

</style>
